import { Z_TEXT } from '@common/schemas';

export const UAI_REGEX = /^\d{7}[A-Za-z]$/;

export const Z_UAI = Z_TEXT('Le champ "UAI" est obligatoire.')
  .regex(UAI_REGEX, { error: 'Le champ "UAI" doit respecter le format suivant : 7 chiffres suivi d\'une lettre.' });

export const UAI_PLACEHOLDER = '0542463J';